module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth1.4191914c.png";